import { Button, Card, CardBody, Content, ContentVariants, Flex, FlexItem } from "@patternfly/react-core";
import appDevelopment from "../../../../../assets/app-development.png";
import "./AddProductInfoCard.scss";
import Env from "../../../../../utils/env";

type AddProductInfoCardProps = { heading: string };

export const AddProductInfoCard = ({ heading }: AddProductInfoCardProps) => (
	<Card className="add-product-info-card">
		<CardBody>
			<Flex justifyContent={{ default: "justifyContentSpaceBetween" }} alignItems={{ default: "alignItemsFlexStart" }}>
				<FlexItem>
					<Content>
						<Content component={ContentVariants.h3}>{heading}</Content>
					</Content>
					<Button
						isInline
						variant="link"
						component="a"
						href={`${Env.ConnectPortalUrls[Env.getEnvName()]}manage/products`}
						target="_blank"
					>
						Add a new product
					</Button>
				</FlexItem>
				<FlexItem>
					<img aria-hidden={true} alt="application development" src={appDevelopment} />
				</FlexItem>
			</Flex>
		</CardBody>
	</Card>
);
